class ProductCard extends HTMLElement {
  constructor() {
    super();
    if (!('ontouchstart' in window)) {
      this.playPauseVideo();
    } else {
      this.removeHoverElements();
    }
  }

  removeHoverElements() {
    this.querySelectorAll('[data-hover-element]').forEach((element) => element.remove());
  }

  playPauseVideo() {
    const video = this.querySelector('video');
    if (!video) return;

    this.addEventListener('mouseenter', () => {
      video.currentTime = 0;
      video.play();
    });

    this.addEventListener('mouseleave', () => video.pause());
  }
}

customElements.define('product-card', ProductCard);
